export default {
  favorites: [],
  lessons: [],
  count: 0,
  lesson: null
};
